import React from 'react';
import { observer, inject } from 'mobx-react';
import { Alert } from 'sd-ui-components';

@inject('NotificationsStore')
@observer
export default class Notifications extends React.Component {
  render() {
    const { NotificationsStore } = this.props;

    return (
      <div>
        {NotificationsStore.notifications.map((notification, index) => (
          <Alert
            key={index}
            className="notifications"
            type={notification.type}
            message={notification.message}
            showIcon
          />
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Notifications/Notifications.jsx